import { trackEvent, ACTIONS } from 'common/analytics';

export class TeamAnalytics {
  static CATEGORY = 'team';

  static trackAddTeamMemberClick() {
    trackEvent(TeamAnalytics.CATEGORY, ACTIONS.CLICK, 'add-team-member');
  }
}
